'use client'

import NextImage from 'next/image'
import FsLightbox from 'fslightbox-react'
import {
  usePropertyMosaic,
  usePropertyMosaicProps
} from './use-property-mosaic'

export type PropertyMosaicProps = usePropertyMosaicProps

const PropertyMosaic = (props: PropertyMosaicProps) => {
  const {
    className,
    styles,
    getGridClass,
    lightboxController,
    openLightboxImage,
    data
  } = usePropertyMosaic(props)

  return (
    <>
      <div className={styles.base({ className })}>
        {data.map((item, index) => {
          return (
            <div
              key={item.id}
              className={styles.item({ className: getGridClass(index) })}
              onClick={() => openLightboxImage(index + 1)}
            >
              <NextImage
                fill
                className={styles.image()}
                src={item.image}
                alt={item.title || 'image'}
              />
            </div>
          )
        })}
      </div>
      <FsLightbox
        type="image"
        toggler={lightboxController.toggler}
        slide={lightboxController.slide}
        sources={data.map(({ image }) => image)}
      />
    </>
  )
}

export default PropertyMosaic
